import React, { useEffect, useReducer, useState } from "react"
import SiteContext from "./components/context/SiteContext"
import SiteReducer from "./components/context/SiteReducer"
import IRSHeader from "./components/IRSHeader"
import IRSFooter from "./components/IRSFooter"
import MainContent from "./App/MainContent"
import IRSNavBar from "./components/IRSNavBar"
import Stickyfill from "stickyfilljs"

import {
  ADD_SITE,
  CLOSE_LANG,
  TOGGLE_LANG,
  TOGGLE_SEARCH,
  TOGGLE_MENU,
  TOGGLE_NAV
} from "./components/context/types"

const version = "long",
  site = require(`./components/context/${version}/OutageMessage.json`),
  jsonURL = 'https://saeite.www4.irs.gov/eauth/static/OutageMessage.json'

const initialState = {
  site: site,
  menuState: false,
  langState: false
}

function getWindowDimensions() {
  const {
    innerWidth: width,
    innerHeight: height
  } = window
  return {
    width,
    height
  }
}

const App = () => {
  const [state, dispatch] = useReducer(SiteReducer, initialState)

  useEffect(() => {
    const fetchData = () => {
      fetch(jsonURL)
        .then(response => {
          return response.json()
        })
        .then(myJson => {
          addSite(myJson)
        })
    }
    fetchData()
  }, [])

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )

  const { width } = windowDimensions

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    const handleKeydown = (event) => {
      if (event.keyCode === 27) {
        toggleNav(null)
        if (state.site.search.show) {
          toggleSearch()
        }
        if (state.langState) {
          toggleLang()
        }
      }

      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener("keydown", handleKeydown)
    return () => window.removeEventListener("keydown", handleKeydown)
  }, [state])

  const addSite = site => {
    dispatch({
      type: ADD_SITE,
      payload: site
    })
  }

  const toggleMenu = (e) => {
    if (e) {
      e.preventDefault()
    }

    dispatch({
      type: TOGGLE_MENU,
      payload: !state.menuState
    })

    if (state.site.search.show) {
      toggleSearch()
    }

    const addBodyClass = () => document.body.classList.add("openMenu")
    const removeBodyClass = () => document.body.classList.remove("openMenu")

    let root = document.getElementsByTagName("html")[0]

    state.menuState ? removeBodyClass() : addBodyClass()
    state.menuState ? root.removeAttribute("class", "openMenu") : root.setAttribute("class", "openMenu")
  }

  const toggleLang = () => {
    dispatch({
      type: TOGGLE_LANG,
      payload: !state.langState
    })
  }

  const closeLang = () => {
    dispatch({
      type: CLOSE_LANG,
      payload: false
    })
  }

  const toggleSearch = (e) => {
    if (e) {
      e.preventDefault()
      window.setTimeout(() => {
        document.getElementById('header-search').focus();
      }, 0)
    }

    const newSearch = {
      ...state.site.search,
      show: !state.site.search.show,
    }

    dispatch({
      type: TOGGLE_SEARCH,
      payload: newSearch
    })

    if (state.menuState) {
      dispatch({
        type: TOGGLE_MENU,
        payload: !state.menuState
      })
    }
  }

  const toggleNav = key => {
    dispatch({
      type: TOGGLE_NAV,
      payload: key
    })
  }

  const handleClick = e => {
    const langNode = document.getElementById("languageButton")
    const navLangNode = document.getElementById("navLangButton")

    if (langNode === e.target) {
      return
    }

    if (navLangNode === e.target) {
      return
    }

    if (state.langState) {
      closeLang()
    }
    if (!state.menuState) {
      toggleNav(null)
    }
  }

  const submitSearch = formID => {
    document.getElementById(formID).submit()
  }

  useEffect(() => {
    var elements = document.querySelectorAll(".isStickyNav")
    Stickyfill.add(elements)

    document.addEventListener("mousedown", handleClick)

    return () => {
      document.removeEventListener("mousedown", handleClick)
    }
  })

  const AMW = {
    site: state.site,
    addSite,
    menuState: state.menuState,
    toggleMenu,
    langState: state.langState,
    toggleLang,
    closeLang,
    toggleSearch,
    toggleNav,
    submitSearch,
    width,
    overviewText: state.site.overviewText
  }

  return (
    <SiteContext.Provider value={AMW} >
      <IRSHeader />
      <IRSNavBar />
      <MainContent />
      <IRSFooter />
    </SiteContext.Provider>
  )
}

export default App
